export default "__VITE_ASSET__D7he5AdV__"